import { getPromoBarHeight } from "//auriccosmetics.com/cdn/shop/t/51/assets/dom.js?v=175014698423836044041769873105";
import debounce from "//auriccosmetics.com/cdn/shop/t/51/assets/debounce.js?v=9266546181275830381769873105";

const MENU_ASIDE_CLASSNAME = 'menu-aside';
const MENU_ASIDE_EXPANDER_BUTTON_CLASSNAME = 'menu-aside__button--expander';
const MENU_ASIDE_EXPANDER_LIST_CLASSNAME = 'menu-aside__expander-list';
const MENU_BUTTON_CLASSNAME = 'menu-button';

const menuAside = document.querySelector(`.${MENU_ASIDE_CLASSNAME}`);
const menu_button = document.querySelectorAll(`.${MENU_BUTTON_CLASSNAME}`);
const expanderButtons = document.querySelectorAll(`.${MENU_ASIDE_EXPANDER_BUTTON_CLASSNAME}`);


const setMenuAsidePosition = () => {
  const promoBarHeight = getPromoBarHeight();

  if (promoBarHeight > 0) {
    let offset = Math.max(0, promoBarHeight - window.scrollY)
    menuAside.style.top = `${offset}px`;
    menuAside.style.height = `calc(100% - ${offset}px)`;
  } else {
    menuAside.style.top = '0';
    menuAside.style.height = '100%';
  }
};

const expandExpander = (expanderButton) => {
  const expanderField = expanderButton.parentElement;
  const expanderList = expanderButton.parentElement.querySelector(`.${MENU_ASIDE_EXPANDER_LIST_CLASSNAME}`);

  let expanderListHeight = expanderList.offsetHeight;
  expanderListHeight += parseInt(window.getComputedStyle(expanderList).getPropertyValue('margin-top'));
  expanderListHeight += parseInt(window.getComputedStyle(expanderList).getPropertyValue('margin-bottom'));

  expanderField.classList.toggle('show');
  expanderButton.classList.toggle('show');
  expanderList.classList.toggle('show');

  if (expanderField.classList.contains('show')){
    expanderField.style.maxHeight = `calc(54px + ${expanderListHeight}px)`;
    expanderField.style.height = `calc(54px + ${expanderListHeight}px)`;
  } else {
    expanderField.style.maxHeight = `54px`;
    expanderField.style.height = `54px`;
  }
};

if (menuAside) {
  window.addEventListener('load', setMenuAsidePosition);
  window.addEventListener('resize', debounce(setMenuAsidePosition, 100));
}

if (expanderButtons.length > 0) {
  expanderButtons.forEach(element => element.addEventListener('click', () => {expandExpander(element)}));
}

menu_button.forEach(element => element.addEventListener('click', setMenuAsidePosition));
